export const getDefaultValues = (type) => {
    const mappings = {
        odoo: {
            lead_id: "id",
            status: "won_status",
            event_time: "write_date"
        },
        b24: {
            lead_id: "id",
            status: "status",
            event_time: "update_time"
        },
        dynamics: {
            lead_id: "leadid",
            status: "statuscode",
            event_time: "modifiedon"
        },
        freshsales: {
            lead_id: "external_id",
            status: "contact_status_id",
            event_time: "updated_at"
        },
        lsqrd: {
            lead_id: "ProspectID",
            event_time: "ModifiedOn"
        },
        monday: {
            lead_id: "id",
            status: "lead_status",
            event_time: "updated_at"
        },
        pipe: {
            lead_id: "id",
            status: "status",
            event_time: "update_time"
        },
        salesforce: {
            lead_id: "Id",
            status: "Status",
            event_time: "LastModifiedDate"
        },
        vtiger: {
            lead_id: "lead_no",
            status: "leadstatus",
            event_time: "modifiedtime"
        },
        zendesk_sell: {
            lead_id: "id",
            status: "status",
            event_time: "updated_at"
        },
        zoho: {
            lead_id: "Lead_id",
            status: "Lead_Status",
            event_time: "Modified_Time"
        },
        hub: {
            lead_id: "hs_lead_id",
            status: "hs_lead_status",
            event_time: "notes_last_updated"
        }
    };

    return mappings[type] || null;
};